import React, { useState } from 'react';
import CustomCard from '../CustomCard';
import { Button } from 'react-bootstrap';

const ToggleViewSwitch = ({
  leftTitle = 'Poprzednia oferta',
  rightTitle = 'Nowa oferta',
  left,
  right,
  style,
  defaultRight = true,
  className = '',
}) => {
  const [isRight, setIsRight] = useState(defaultRight);

  return (
    <div className={`toggle-view-switch ${className}`} style={style}>
      <CustomCard withoutPadding={true} withoutHeader={true}>
        <div className="d-flex justify-content-between align-items-center">
          <Button
            variant={isRight ? 'secondary' : 'primary'}
            size={'sm'}
            onClick={() => setIsRight(false)}
          >
            {leftTitle}
          </Button>

          <div className="form-check form-switch d-flex align-items-center">
            <input
              className="form-check-input"
              type="checkbox"
              id="toggle-switch"
              style={{
                width: '4rem',
                height: '2rem',
                cursor: 'pointer',
              }}
              checked={isRight}
              onChange={() => setIsRight(!isRight)}
            />
          </div>

          <Button
            variant={isRight ? 'primary' : 'secondary'}
            size={'sm'}
            onClick={() => setIsRight(true)}
          >
            {rightTitle}
          </Button>
        </div>
      </CustomCard>

      <div className={'mt-2'}>{isRight ? right : left}</div>
    </div>
  );
};

export default ToggleViewSwitch;
